import { withPluginApi } from "discourse/lib/plugin-api";
import { transformerWasAdded } from "discourse/lib/transformer";

// Disables the AI Spam tab toggle when the spam config is flagged enabled_locked.
// The transformer only exists on core versions that expose it, so older releases
// fall back to the server-side validator alone.
function initialize(api) {
  if (!transformerWasAdded("ai-spam-toggle-disabled", "VALUE")) {
    return;
  }

  api.registerValueTransformer(
    "ai-spam-toggle-disabled",
    ({ value, context }) => value || !!context?.spam?.enabled_locked
  );
}

export default {
  name: "lock-ai-spam-toggle",
  initialize() {
    withPluginApi(initialize);
  },
};
